module.exports = __webpack_public_path__ + "img/violet_069.be49dd96.png";